module.exports = __webpack_public_path__ + "img/3f_l_newtokyo.54a28ba8.png";